import { Button, Empty, List, Row } from 'antd';
import React, { useState } from 'react';
import {
  updateTrainerInfo,
  uploadTrainerImage,
} from '../../../services/trainerServices';
import InterestEdit from './InterestEdit';
import InterestsCard from './InterestsCard';
import { beforeImageUpload } from '../../../utilities/imageUpload';

function Interests({ trainer, updateTrainerLocalData, updateTrainerData }) {
  const [initialValues, setInitialValues] = useState({
    title: '',
    imageLink: '',
    description: '',
  });

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [status, setStatus] = useState({ type: 'IDLE', message: 'Idle mode.' });

  function toggleAdd() {
    setIsAddOpen((prev) => !prev);
  }

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Loading data!' });
    let interests = [...trainer.interests];
    interests.push(values);
    let trainerData = {
      ...trainer,
      interests,
    };
    await updateTrainerData(trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  const onImageUpload = async (e) => {
    const formData = new FormData();
    formData.append('name', e.file.name);
    formData.append('image', e.file);
    await uploadTrainerImage(formData, 'assets')
      .then((res) => {
        setInitialValues({
          ...initialValues,
          ...{ imageLink: res.data.imageUrl },
        });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <div>
      <Row justify="space-between">
        <h2>Interests</h2>
        <Button onClick={toggleAdd} type="primary">
          Add
        </Button>
      </Row>
      {trainer.interests?.length ? (
        <List
          itemLayout="vertical"
          size="large"
          dataSource={trainer.interests}
          renderItem={(item, index) => (
            <InterestsCard
              key={index}
              index={index}
              item={item}
              trainer={trainer}
              updateTrainerLocalData={updateTrainerLocalData}
              updateTrainerData={updateTrainerData}
            />
          )}
        />
      ) : (
        <Empty />
      )}
      <InterestEdit
        type="ADD"
        initialValues={initialValues}
        isOpen={isAddOpen}
        status={status}
        toggle={toggleAdd}
        onSubmit={onSubmit}
        beforeImageUpload={beforeImageUpload}
        onImageUpload={onImageUpload}
      />
    </div>
  );
}

export default Interests;
